module.exports = __webpack_public_path__ + "img/background.5e4d4d1c.png";